import React from 'react';
import { Button, useFileInput } from '@gravity-ui/uikit';
export const ButtonAttach = ({ onUpdate, onChange, multiple, buttonProps, accept, children, }) => {
    const { controlProps, triggerProps } = useFileInput({ onUpdate, onChange });
    return (React.createElement(React.Fragment, null,
        React.createElement("input", Object.assign({ type: "file", multiple: multiple, accept: accept }, controlProps)),
        React.createElement(Button, Object.assign({}, buttonProps, triggerProps), children)));
};
